import { registerFormInputComponent } from '@vendure/admin-ui/core';
import { CustomerSelectorComponent } from './customer-selector/customer-selector.component';
import { CollectionSelectorComponent } from './collection-selector/collection-selector.component';

export default [
    registerFormInputComponent('customer-selector-input', CustomerSelectorComponent),
    registerFormInputComponent('collection-selector-input', CollectionSelectorComponent),
];
